module.exports = __webpack_public_path__ + "img/hg38nsj.c33a6a07.jpg";